import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    customerData: {},
    branchData: {},
    userBranch: {},
    userTreasuries: {},
    userStores: {},
    userItineraries: {},
    token: '',
    userName: '',
    userID: 0
  },
  mutations: {
    SET_CustomerData (state, payload) {
      state.customerData = payload
    },
    SET_Token (state, payload) {
      state.token = payload
    },
    SET_BranchData (state, payload) {
      state.branchData = payload
    },
    SET_UserBranch (state, payload) {
      state.userBranch = payload
    },
    SET_UserTreasuries (state, payload) {
      state.userTreasuries = payload
    },
    SET_UserStores (state, payload) {
      state.userStores = payload
    },
    SET_UserItineraries (state, payload) {
      state.userItineraries = payload
    },
    SET_UserName (state, payload) {
      state.userName = payload
    },
    SET_UserID (state, payload) {
      state.userID = payload
    }
  },
  actions: {
    // ----------------------------------------------------
    apiCall ({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post('https://plfilters.com/api/api/' & payload.url, {
            token: localStorage.getItem('token'),
            data: payload.data
          })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // ----------------------------------------------------
    getAllCustomerData ({commit}, payload) {
      commit('SET_CustomerData', payload)
    }
  },
  getters: {
    get_token (state) {
      return state.token
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js